export enum IntegrationType {
  OWNERREZ = 'OwnerRez',
  HOSPITABLE = 'Hospitable',
  HOSPITABLE_CONNECT = 'Hospitable Connect',
  HOSTAWAY = 'Hostaway',
  GUESTY = 'Guesty',
  LODGIFY = 'Lodgify',
}
